(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('MoneyServiceEarlyPaymentsController', MoneyServiceEarlyPaymentsController);

    MoneyServiceEarlyPaymentsController.$inject = [
        '$http', '$location', '$window', '$mdDialog', 'AlertService', 'paginationConstants',
        'isAdmin', 'isFinancialTeam', 'isCCR'
    ];

    function MoneyServiceEarlyPaymentsController(
        $http, $location, $window, $mdDialog, AlertService, paginationConstants,
        isAdmin, isFinancialTeam, isCCR
    ) {
        var vm = this;

        vm.isAdmin = isAdmin;
        vm.isFinancialTeam = isFinancialTeam;
        vm.isCCR = isCCR;
        vm.canEdit = isAdmin || isFinancialTeam || isCCR;

        vm.fromDate = defaultFromDate();
        vm.toDate = defaultToDate();
        vm.appraisalOrderId = null;
        vm.hidePaid = true;
        vm.showOutstanding = false;
        vm.loading = false;
        vm.entries = [];
        // Params used by the most recent successful load(). Export reuses these so the
        // CSV is guaranteed to reflect the rows currently shown on screen, even if the
        // user edits a filter input without clicking Search again.
        vm.lastLoadedParams = null;
        vm.totalElements = 0;
        vm.page = 1;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.predicate = 'paymentDueDate';
        vm.ascending = true;

        vm.load = load;
        vm.search = search;
        vm.reset = reset;
        vm.applyMonthToDate = applyMonthToDate;
        vm.togglePaid = togglePaid;
        vm.openEditDialog = openEditDialog;
        vm.exportReport = exportReport;
        vm.onPageChange = onPageChange;
        vm.onSortChange = onSortChange;
        vm.copyToClipboard = copyToClipboard;

        var deepLinkParams = $location.search();
        if (deepLinkParams.appraisalOrderId) {
            vm.appraisalOrderId = parseInt(deepLinkParams.appraisalOrderId, 10);
            vm.fromDate = null;
            vm.toDate = null;
            vm.hidePaid = false;
            vm.showOutstanding = false;
        }

        load();

        // Filter params shared between the data query and the export. load() adds
        // paging/sort on top; export() consumes the snapshot saved into
        // vm.lastLoadedParams so the CSV row-set always matches what's on screen.
        function buildFilterParams() {
            var params = {};
            if (vm.fromDate) {
                params.from = moment(vm.fromDate).format('YYYY-MM-DD');
            }
            if (vm.toDate) {
                params.to = moment(vm.toDate).format('YYYY-MM-DD');
            }
            if (vm.appraisalOrderId) {
                params.appraisalOrderId = vm.appraisalOrderId;
            }
            if (vm.hidePaid) {
                params.hidePaid = true;
            }
            if (vm.showOutstanding) {
                params.showOutstanding = true;
            }
            return params;
        }

        function load() {
            vm.loading = true;
            var filterParams = buildFilterParams();
            var loadParams = angular.extend({}, filterParams, {
                page: vm.page - 1,
                size: vm.itemsPerPage,
                sort: vm.predicate + ',' + (vm.ascending ? 'asc' : 'desc')
            });
            $http.get('api/accounting/money-service-early-payments', { params: loadParams })
                .then(function(response) {
                    vm.entries = (response.data || []).map(function(e) {
                        e._paid = !!e.paidDateTime;
                        return e;
                    });
                    vm.totalElements = parseInt(response.headers('X-Total-Count'), 10) || 0;
                    vm.lastLoadedParams = filterParams;
                    vm.loading = false;
                })
                .catch(function(err) {
                    vm.loading = false;
                    AlertService.error((err.data && err.data.message) || err.statusText || 'Request failed');
                });
        }

        function search() {
            vm.page = 1;
            load();
        }

        function applyMonthToDate() {
            vm.fromDate = moment().startOf('month').toDate();
            vm.toDate = new Date();
            vm.page = 1;
            load();
        }

        function reset() {
            vm.fromDate = defaultFromDate();
            vm.toDate = defaultToDate();
            vm.appraisalOrderId = null;
            vm.hidePaid = true;
            vm.showOutstanding = false;
            vm.page = 1;
            load();
        }

        function defaultFromDate() {
            return moment().subtract(1, 'month').toDate();
        }

        function defaultToDate() {
            return moment().add(14, 'days').toDate();
        }

        function onPageChange() {
            load();
        }

        function onSortChange() {
            vm.page = 1;
            load();
        }

        function copyToClipboard(text) {
            if (!text) return;
            navigator.clipboard.writeText(String(text)).then(function() {
                AlertService.success('Copied to clipboard: ' + text);
            });
        }

        function togglePaid(entry) {
            $http.put('api/accounting/money-service-early-payments/' + entry.id + '/paid', null, { params: { paid: entry._paid } })
                .then(function(response) {
                    var updated = response.data;
                    updated._paid = !!updated.paidDateTime;
                    var idx = vm.entries.indexOf(entry);
                    if (idx >= 0) {
                        vm.entries[idx] = updated;
                    }
                })
                .catch(function(err) {
                    entry._paid = !entry._paid;
                    AlertService.error((err.data && err.data.message) || err.statusText || 'Failed to update paid status');
                });
        }

        function openEditDialog(entry) {
            $mdDialog.show({
                templateUrl: 'app/report/money-service-early-payments-edit-dialog.html',
                controller: EditDialogController,
                controllerAs: 'dialog',
                locals: { entry: entry },
                clickOutsideToClose: true
            }).then(function(updated) {
                if (!updated) return;
                updated._paid = !!updated.paidDateTime;
                var idx = vm.entries.indexOf(entry);
                if (idx >= 0) {
                    vm.entries[idx] = updated;
                }
            });
        }

        function exportReport() {
            // Use the filters captured on the most recent successful load() — NOT the
            // current vm.* values. If the user edits a filter input without clicking
            // Search, the table on screen still reflects the previous filters, and the
            // CSV must reflect the same data set. If no load has succeeded yet, fall
            // back to the current filter values.
            var snapshot = vm.lastLoadedParams || buildFilterParams();
            var parts = [];
            Object.keys(snapshot).forEach(function(key) {
                parts.push(encodeURIComponent(key) + '=' + encodeURIComponent(snapshot[key]));
            });
            // Keep the CSV ordering in sync with the on-screen table by passing the
            // same sort the report query uses. The export endpoint ignores paging and
            // returns every matching row, but honours this sort.
            parts.push('sort=' + encodeURIComponent(vm.predicate + ',' + (vm.ascending ? 'asc' : 'desc')));
            var url = 'api/accounting/money-service-early-payments/export' + (parts.length ? '?' + parts.join('&') : '');
            $window.open(url, '_blank', 'noopener,noreferrer');
        }

        EditDialogController.$inject = ['$mdDialog', '$http', 'AlertService', 'entry'];

        function EditDialogController($mdDialog, $http, AlertService, entry) {
            var dialog = this;
            dialog.paymentDueDate = entry.paymentDueDate ? new Date(entry.paymentDueDate + 'T12:00:00') : null;
            dialog.comments = entry.comments;
            // paidAmount is only editable when the entry is marked paid. For unpaid
            // entries the input is hidden and never sent on the wire — the backend
            // rejects paidAmount writes on unpaid entries.
            dialog.isPaid = !!entry.paidDateTime;
            dialog.paidAmount = dialog.isPaid ? entry.paidAmount : null;

            dialog.save = function() {
                var payload = {
                    paymentDueDate: dialog.paymentDueDate ? moment(dialog.paymentDueDate).format('YYYY-MM-DD') : null,
                    comments: dialog.comments
                };
                if (dialog.isPaid) {
                    payload.paidAmount = dialog.paidAmount;
                }
                $http.put('api/accounting/money-service-early-payments/' + entry.id, payload)
                    .then(function(response) {
                        $mdDialog.hide(response.data);
                    })
                    .catch(function(err) {
                        AlertService.error((err.data && err.data.message) || err.statusText || 'Failed to save');
                    });
            };

            dialog.cancel = function() {
                $mdDialog.cancel();
            };
        }
    }
})();
